export default "__VITE_ASSET__CYnTBYZL__"